import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import MUILinearProgress from "@mui/material/LinearProgress";
const LinearProgress = ({
  classes
}) => {
  return /*#__PURE__*/React.createElement(MUILinearProgress, {
    classes: {
      root: classes.progressRoot,
      bar1Indeterminate: classes.progressBar1,
      bar2Indeterminate: classes.progressBar2
    }
  });
};
const styles = {
  progressRoot: {
    height: 2,
    position: "absolute",
    zIndex: 1,
    width: "100%",
    bottom: 0
  },
  progressBar1: {
    animation: "$linear-progress 0.5s cubic-bezier(1, 1, 1, 1) infinite"
  },
  "@keyframes linear-progress": {
    "0%": {
      left: "-200%",
      right: "100%"
    },
    "60%": {
      left: "107%",
      right: "-8%"
    },
    "100%": {
      left: "107%",
      right: "-8%"
    }
  },
  progressBar2: {
    display: "none"
  }
};
export default withStyles(styles)(LinearProgress);
LinearProgress.propTypes = {
  classes: PropTypes.object.isRequired
};